import { BOOKING_GA_CATEGORIES, BookingPathKeys } from '../../paths';

export const BOOKING_COMPLETE_STRINGS = {
    AnonymousPatientName: 'Hey',
    AppointmentBooked: 'Your appointment is booked!',
    AppointmentBookedWithDoctor: 'You are scheduled with ',
    AppointmentBookedWithDoctorZocdocVideoVisit:
        'Your video visit is scheduled with ',
    BookAnAppointment: 'Book an appointment',
    ContinueToCheckin: 'Continue to check-in',
    DownloadTheApp: 'Download the app',
    DownloadTheAppMessage:
        'Scan your insurance card and we will verify your plan and send it to the doctor.',
    FillOutForms: 'Fill out forms',
    FillOutFormsDescription:
        'Skip the long paper forms at the office, fill out your check in information now.',
    ModalAppointmentBooked: 'Appointment booked!',
    ModalMessageDesktop:
        "We want you to be well, so we've set up a Well Guide for you to stay on top of your health",
    ModalMessageMobile:
        'Stay on top of your health by booking one of these preventative appointments.',
    PageTitle: 'Zocdoc | Booking | Complete',
    RecommendationHeaderDental: 'Dental cleaning',
    RecommendationHeaderSkin: 'Skin screening',
    RecommendationHeaderVision: 'Vision exam',
    RecommendationMessageDental:
        'Prevents cavities and gingivitis by removing plaque from teeth.',
    RecommendationMessageSkin:
        'Short and pain free, the doctor simply searches for spots that may be problematic.',
    RecommendationMessageVision:
        'Not only can they help you see better, they can check for other non-eye related issues.',
    TrySendingInsuranceCardTextAgain: " Let's try that again",
    UpToDate: 'Up to date!',
    VideoVisitBooked: 'Your video visit is booked!',
    WellnessCompleteMessage:
        'Congrats on being on top of your well guide appointments.',
    WellnessDoctorMessage:
        'A new, healthier you is at your fingertips. Book your remaining wellness appointments today.',
};

export const BOOKING_COMPLETE_CAROUSEL_STRINGS = {
    CarouselHeaderDental: 'When was your last dental cleaning?',
    CarouselHeaderPhysical: 'When was your last physical?',
    CarouselHeaderSkin: 'When was your last skin screening?',
    CarouselHeaderVision: 'When was your last vision exam?',
    CarouselMessageDental:
        'The American Dental Association recommends a checkup twice a year. Click, smile, repeat.',
    CarouselMessagePhysical:
        'The US Preventive Services Task Force recommends that adults get a blood pressure screening, the CDC recommends an annual Flu shot, use your annual physical to discuss these with your doctor.',
    CarouselMessageSkin:
        'The American Cancer Society recommends an annual skin screening for everyone 20 to 80 years of age.',
    CarouselMessageVision:
        'The American Academy of Ophthalmology recommends an eye health exam every 2 years for adults ages 20 to 80.',
};

export const BOOKING_COMPLETE_GA_CATEGORY =
    BOOKING_GA_CATEGORIES[BookingPathKeys.bookingCompletePath];
export const BOOKINGS_GA_CATEGORY = 'Bookings';
export const BOOKINGCOMPLETE_GA_CATEGORY = 'BookingComplete';

export const GaActionText = {
    insuranceCaptureTextWasSent: 'queued insurance card capture text to send',
    trackClickGoogle: 'Click Google',
    trackClickIcal: 'Click ICal',
    trackClickOutlook: 'Click Outlook',
    trackMadeItToBookingComplete: 'Made it to Booking Complete',
    trackClickViewAppointments: 'Click View Appointments',
    trackClickCall: 'Click Call',
    trackClickAddToCalendar: 'Click Add To Calendar',
    trackClickCheckIn: 'Click Check In',
    trackBookedAppt: 'BookedAppt',
    trackClickDownloadApp: 'Click Download App',
    trackBooked: 'Booked',
    trackBookedCovidVaccinationDose1: 'Booked Covid Vaccine Dose 1',
    trackBookedCovidVaccinationDose2: 'Booked Covid Vaccine Dose 2',
    trackClickNewBooking: 'Click New Booking',
    trackOutOfNetworkWarning: 'Out of Network Warning Modal',
    trackAppointmentInstructionsShown: 'Showed Appointment Instructions',
};

export const RECOMMENDATION_INFO = {
    DENTAL: {
        TYPE: 'dental',
        PROCEDURE_ID: 11,
        SPECIALTY_ID: 98,
    },
    PHYSICAL: {
        TYPE: 'physical',
        PROCEDURE_ID: 76,
        SPECIALTY_ID: 153,
    },
    SKIN: {
        TYPE: 'skin',
        PROCEDURE_ID: 85,
        SPECIALTY_ID: 101,
    },
    VISION: {
        TYPE: 'vision',
        PROCEDURE_ID: 92,
        SPECIALTY_ID: 386,
    },
};

export const RECOMMENDATION_TYPE = {
    DENTAL_CLEANING: 'dental',
    VISION_EXAM: 'vision',
    SKIN_SCREENING: 'skin',
};

export const COVID_VACCINE_DOSE_1_PROCEDURE_ID = '5243';
export const COVID_VACCINE_DOSE_2_PROCEDURE_ID = '5244';

export const COVID_VACCINE_REBOOKING_DIRECTORY_IDS = [
    '748', // Test directory
];

export const COVID_VACCINE_EMAILCONFIRMATION_DIRECTORY_IDS = [
    '748', // Test directory
    '1139', // Valley
];
